module.exports = __webpack_public_path__ + "img/3f_l_sapporo@2x.8f884b74.png";